//FlexiItemContent: To be used by standardized controllers. Controllers hold configuration.contentelements which this controller digests and renders.
//With rendering and a full configuration system, we may as well roll out a new onChange handler, maybe just break that out into a separate functional controller. 
//REMEMBER THESE CONCEPTS:
//     localstate.itemdata is the WHAT
//     configuration.contentelements....(where element.type===someinputtype) will need validation rules (element.validationrules) per input
//

import React, { useState, useContext } from 'react';
import { AppContext } from '../../Auth/contexts/AppContext'; 

import FlexiItemChangeHandler from './FlexiItemChangeHandler';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Select from '@mui/material/Select';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Checkbox from '@mui/material/Checkbox';

//DateTime
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; //Possibly our new adapter for mui x 7 datetime
import dayjs from 'dayjs'; //Used with new datetimepickers
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import ViewListIcon from '@mui/icons-material/ViewList';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import { Link } from 'react-router-dom';

//DBAutoComplete
import DBAutoComplete from '../../common/DBAutoComplete';


const hostbase = process.env.REACT_APP_BASE;


const CheckRenderRequirements = ({ element, localstate }) => {
	var levelpass = false;
	var renderelement = false;
	if (element.renderrequirements) {
		//console.log("Start of check");
		for (var i = 0; i < element.renderrequirements.length; i++) {
			//console.log("Looping reqs");
			for (var j = 0; j < element.renderrequirements[i].values.length; j++) {
				// console.log("Key:"+localstate.itemdata[element.renderrequirements[i].key]);
				// console.log("Looping values:"+element.renderrequirements[i].values[j]);
				if (localstate.itemdata[element.renderrequirements[i].key] == element.renderrequirements[i].values[j]) {
					//If there are multiple requirements, we need to make sure they all pass.
					levelpass = true;
					console.log("Level passed");

					//If we're at the last level, good! We're done! Allow render!
					if (i + 1 === element.renderrequirements.length) {
						renderelement = true;
					}
				}
			}
			//If the current level doesn't pass, end this function.
			if (levelpass) {
				//Reset level pass and continue
				levelpass = false;
				continue;
			} else {
				break;
			}
		}
	} else {
		renderelement = true;
	}
	return renderelement;
}

const CheckEnabledRequirements = ({ element, localstate }) => {
	var levelpass = false;
	var enableelement = false;
	if (element.enabledrequirements) {
		//console.log("Start of check");
		for (var i = 0; i < element.enabledrequirements.length; i++) {
			//console.log("Looping reqs");
			for (var j = 0; j < element.enabledrequirements[i].values.length; j++) {
				// console.log("Key:"+localstate.itemdata[element.enabledrequirements[i].key]);
				// console.log("Looping values:"+element.enabledrequirements[i].values[j]);
				if (localstate.itemdata[element.enabledrequirements[i].key] == element.enabledrequirements[i].values[j]) {
					//If there are multiple requirements, we need to make sure they all pass.
					levelpass = true;
					console.log("Level passed");

					//If we're at the last level, good! We're done! Allow render!
					if (i + 1 === element.enabledrequirements.length) {
						enableelement = true;
					}
				}
			}
			//If the current level doesn't pass, end this function.
			if (levelpass) {
				//Reset level pass and continue
				levelpass = false;
				continue;
			} else {
				break;
			}
		}
	} else {
		enableelement = true;
	}
	return enableelement;
}



//Allow recursive creation of elements. Woah!
const RenderElement = ({ configuration, element, localstate, UpdateState, classes, perms }) => {
	switch (element.rendertype) {
		case "section":
			return <RenderSection configuration={configuration} element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "gridcontainer":
			return <RenderGridContainer configuration={configuration} element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvheader":
			return <KVHeader element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvstaticinputtext":
			return <KVRenderStaticInputText element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} />;
		case "kvinputtext":
			return <KVRenderInputText element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvinputserial":
			return <KVRenderInputSerial element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvinputnumber":
			return <KVRenderInputNumber element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvstaticselect":
			return <KVRenderStaticSelect element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
case "kvcustomlink":
	return <KVRenderCustomLink element={element} localstate={localstate} classes={classes} perms={perms} />;

		//Datetimes
		case "kvstaticdatetime":
			return <KVRenderStaticDateTime element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvinputdatetime":
			return <KVRenderInputDateTime element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		//Date
		case "kvstaticdate":
			return <KVRenderStaticDate element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvinputdate":
			return <KVRenderInputDate element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		//Button Group
		case "kvinputbuttongroup":
			return <KVRenderInputButtonGroup element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		//Creation User
		case "kvnesteduser":
			return <KVRenderNestedUser element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		//Update User
		case "kvupdateuser":
			return <KVRenderUpdateUser element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		case "kvproductbyid":
			return <KVRenderProductSelection configuration={configuration} element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvpartbyid":
			return <KVRenderPartSelection element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvinputtextarea":
			return <KVRenderInputTextArea element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvinputcheckbox":
			return <KVRenderInputCheckbox element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		//Child Relationships
		case "kvaddtags":
			return <KVRenderAddTags element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvrendertags":
			return <KVRenderTags element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		//MiniGrid
		//Goal: Setup multiple repairs, multiple MDM.... Build-out how a minigrid should work? Add\Remove options, perms.
		case "minigrid":
			return <MiniGrid configuration={configuration} element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		// case "kvaccordionobject":
		// 	return <KVAccordionObject element={element} localstate={localstate} classes={classes} perms={perms} />;
		// case "kvaccordionpairs":
		//   return <KVAccordionPairs element={element} localstate={localstate} classes={classes} />;

		case "kvaccordionsplit":
			return <KVAccordionSplit element={element} localstate={localstate} classes={classes} />;

		case "kvendbuttons":
			return <KVRenderEndButtons element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		default:
			return null;


	}
};

const RenderSection = ({ configuration, element, localstate, UpdateState, classes, perms }) => {
	return (
		<div style={{ borderRadius: "4px", border: "0px solid #BBB", margin: "0px 10px 20px" }}>
			<div style={{ height: "30px", borderBottom: "2px solid #AAA", backgroundColor: "#DDD", textAlign: "left", padding: "5px 0px 1px 8px" }}>
				<span style={{ fontSize: "1.1em", fontWeight: "400" }}>
					{element.title}
				</span>
				{element.description ?
					<span style={{ fontSize: "0.8em" }}> - {element.description}</span> : ""
				}
			</div>
			<div style={{ backgroundColor: "#FFF", padding: "10px" }}>
				{element.children.map((childelement, childelementindex) => {
					return <RenderElement
						key={element.dbfield + "element"}
						configuration={configuration}
						element={childelement}
						localstate={localstate} UpdateState={UpdateState}
						perms={perms}
						classes={classes} />
				})}
			</div>
		</div>
	)
}

const RenderGridContainer = ({ configuration, element, localstate, UpdateState, classes, perms }) => {
	return (
		<Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
			{element.children.map((childelement, childelementindex) => {
				return <RenderGridItem
					key={element.dbfield + "griditem" + childelementindex}
					configuration={configuration}
					element={childelement}
					localstate={localstate}
					UpdateState={UpdateState}
					perms={perms}
					classes={classes} />
			})}
		</Grid>
	)
}

const RenderGridItem = ({ configuration, element, localstate, UpdateState, classes, perms }) => {
	//Doublecheck that this is a grid item.
	if (element.rendertype === "griditem") {
		return (
			<Grid size={{
				xs: element.size.xs,
				sm: element.size.sm,
				md: element.size.md,
				lg: element.size.lg

			}}>
				{element.children.map((childelement, childelementindex) => {
					return <RenderElement
						key={element.dbfield + "gridelement" + childelementindex}
						configuration={configuration}
						element={childelement}
						localstate={localstate}
						UpdateState={UpdateState}
						perms={perms}
						classes={classes} />
				})}
			</Grid>
		)
	}
}

const KVHeader = ({ configuration, element, localstate, UpdateState, classes, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: "100%", flexShrink: 0, padding: element.padding }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign, color: "#444", fontSize: "14px", fontWeight: 550, textDecoration: "underline", textAlign: "center" }}>
					<div style={{ width: "250px", backgroundColor: "#EEE", margin: "auto" }}>
						{element.label}
					</div>
				</div>
			</Grid>
		</Grid>
	)
}

const KVRenderStaticInputText = ({ element, localstate, classes, UpdateState }) => {
	const value = getByPath(localstate.itemdata, element.dbfield);
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
					{value ?? "—"}
				</div>
			</Grid>
		</Grid>
	)
}

const KVRenderInputText = ({ element, localstate, classes, UpdateState, perms }) => {
	if (CheckEnabledRequirements({ element, localstate })) {
		return (
			<Grid container wrap="nowrap">
				<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
					{/* Label */}
					<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
						{element.label}
					</div>
				</Grid>
				<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
					{/* Value */}
					{(perms.updatePerm) &&
						<input className={classes.kvtextinput} style={{ textAlign: element.valuetextAlign }}
							maxLength="100" //Needs max length
							type="text"
							value={localstate.itemdata[element.dbfield]}
							onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
						/>
					}
					{(!perms.updatePerm) &&
						<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
							{localstate.itemdata[element.dbfield]}
						</div>
					}
				</Grid>
			</Grid>
		)
	} else {
		return (
			<Grid container wrap="nowrap">
				<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
					{/* Label */}
					<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
						{element.label}
					</div>
				</Grid>
				<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
					{/* Value */}
					<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
						{localstate.itemdata[element.dbfield]}
					</div>
				</Grid>
			</Grid>
		)
	}
}

const KVRenderInputSerial = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				{(perms.admin || localstate.itemdata.PendingItem === 1 && perms.createPerm) &&
					<input className={classes.kvtextinput} style={{ textAlign: element.valuetextAlign }}
						maxLength="100" //Needs max length
						type="text"
						value={localstate.itemdata[element.dbfield]}
						onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
					/>
				}
				{(!perms.admin && (localstate.itemdata.PendingItem !== 1 || !perms.createPerm)) &&
					<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
						{localstate.itemdata[element.dbfield]}
					</div>
				}
			</Grid>

		</Grid>
	)
}

const KVRenderInputNumber = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				{(perms.updatePerm) &&
					<input className={classes.kvtextinput} style={{ textAlign: element.valuetextAlign }}
						type="number"
						min={element.validation.min}
						max={element.validation.max}
						step={element.step}
						//value={localstate.itemdata[element.dbfield] ? localstate.itemdata[element.dbfield] : 0}
						value={localstate.itemdata[element.dbfield] ?? ''}
						//onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
						onChange={(event) =>
							FlexiItemChangeHandler({
								localstate,
								UpdateState,
								element,
								event: {
									...event,
									target: {
										...event.target,
										value:
											event.target.value === '' ? null : event.target.valueAsNumber
									}
								}
							})
						}
					/>
				}
				{(!perms.updatePerm) &&
					<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
						{localstate.itemdata[element.dbfield]}
					</div>
				}
			</Grid>

		</Grid>
	)
}

const KVRenderStaticSelect = ({ element, localstate, classes, UpdateState, perms }) => {
    // 1. Get the current value from state
    const currentValue = localstate.itemdata[element.dbfield];

    // 2. Check if the current value is inside the disableonvalues array
    const isDisabled = Array.isArray(element.disableonvalues) 
        ? element.disableonvalues.includes(currentValue) 
        : false;

    return (
        <Grid container wrap="nowrap">
            <Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
                {/* Label */}
                <div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
                    {element.label}
                </div>
            </Grid>
            <Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
                {/* Value */}
                {(perms.updatePerm) &&
                    <FormControl variant="standard" className={classes.kvstaticselect} sx={{ m: 0, width: "100%", border: "0px", textAlign: element.valuetextAlign }}>
                        <Select
                            variant="standard"
                            value={currentValue ?? ""} // Added safe fallback
                            displayEmpty
                            disabled={isDisabled} // 3. Apply the disabled state here
                            onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
                            renderValue={(selected) => {
                                const match = element.values.find(v => v.value === selected);
                                return <Typography variant="h6">{match ? match.optionlabel : "-"}</Typography>;
                            }}
                        >
                            {element.values.map((option, elementindex) => {
                                return (
                                    // Added key to prevent React console warnings
                                    <MenuItem key={`${element.dbfield}-${elementindex}`} value={option.value}>
                                        {option.optionlabel}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                }
                {(!perms.updatePerm) &&
                    <div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
                        {/* Ensure we display the label, not just the raw value, in read-only mode if desired */}
                        {(() => {
                            const match = element.values.find(v => v.value === currentValue);
                            return match ? match.optionlabel : (currentValue || "-");
                        })()}
                    </div>
                }
            </Grid>
        </Grid>
    )
}

const KVRenderCustomLink = ({ element, localstate, classes }) => {
	const displayValue = getByPath(localstate.itemdata, element.dbfield);   // e.g. "lot.LotName"
	const linkArgValue = getByPath(localstate.itemdata, element.linkend);   // e.g. "lot.LotName"

	const href =
		linkArgValue !== null && linkArgValue !== undefined && linkArgValue !== ""
			? `${element.linkstart || ""}${encodeURIComponent(linkArgValue)}`
			: null;

	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>

			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
					{href ? (
						<a href={href} style={{ textDecoration: "underline" }}>
							{displayValue ?? linkArgValue}
						</a>
					) : (
						"—"
					)}
				</div>
			</Grid>
		</Grid>
	);
};

const KVRenderStaticDateTime = ({ element, localstate, classes }) => {
	const rawValue = localstate?.itemdata?.[element.dbfield];
	const parsed = dayjs(rawValue);
	const display = parsed.isValid()
		? parsed.format("MMMM D, YYYY [at] h:mma")
		: "—";

	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
					{display}
				</div>
			</Grid>
		</Grid>
	);
};

const KVRenderInputDateTime = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				{(perms.updatePerm) &&
					<div className={classes.flexmuixdatetime} style={{ textAlign: element.valuetextAlign }}>
						<DateTimePicker
							value={localstate.itemdata[element.dbfield]}
							onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
								slotProps={{
									textField: {
										variant: "standard",
										fullWidth: true,
									},
								}}
						/>
					</div>
				}
				{(!perms.updatePerm) &&
					<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
						{dayjs(localstate.itemdata[element.dbfield]).format("MMMM D, YYYY [at] h:mma")}
					</div>
				}
			</Grid>

		</Grid>
	)
}

const KVRenderInputButtonGroup = ({ element, localstate, classes, UpdateState, perms }) => {
	if (CheckRenderRequirements({ element, localstate })) {
		return (
			<Grid container wrap="nowrap">
				<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
					{/* Label */}
					<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
						{element.label}
					</div>
				</Grid>
				<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
					{(perms.updatePerm) &&
						<div style={{ textAlign: element.valuetextAlign }}>
							<ButtonGroup size="small" aria-label="small button group" sx={{ marginBottom: "5px" }}>
								{element.values.map((option, optionindex) => {
									return (
										<Button sx={{
											fontFamily: "Roboto, Helvetica, Arial, sans-serif",
											backgroundColor: option.value == localstate.itemdata[element.dbfield] ? "#01579B" : "#FFF",
											color: option.value == localstate.itemdata[element.dbfield] ? "#FFF" : "#01579B"
										}}
											key={element.dbfield + "option" + optionindex}
											onClick={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event, value: option.value })}>
											{option.value}
										</Button>
									)
								})}
							</ButtonGroup>
						</div>
					}
					{(!perms.updatePerm) &&
						<div style={{ textAlign: element.valuetextAlign }}>
							<ButtonGroup size="small" aria-label="small button group" sx={{ marginBottom: "5px" }}>
								{element.values.map((option, optionindex) => {
									return (
										<Button sx={{ backgroundColor: option.value == localstate.itemdata[element.dbfield] ? "#000" : "#BBB" }}
											key={element.dbfield + "option" + optionindex}>
											{option.value}
										</Button>
									)
								})}
							</ButtonGroup>
						</div>
					}
				</Grid>

			</Grid>
		)
	}

}


const KVRenderStaticDate = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
					{dayjs(localstate.itemdata[element.dbfield]).format("MMMM D, YYYY")}
				</div>
			</Grid>

		</Grid>
	)
}

const KVRenderInputDate = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				{(perms.updatePerm) &&
					<div className={classes.flexmuixdatetime} style={{ textAlign: element.valuetextAlign }}>
						<DatePicker
							value={dayjs(localstate.itemdata[element.dbfield])}
							onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
							slotProps={{
									textField: {
										variant: "standard",
										fullWidth: true,
									},
								}}
						/>
					</div>
				}
				{(!perms.updatePerm) &&
					<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
						{dayjs(localstate.itemdata[element.dbfield]).format("MMMM D, YYYY")}
					</div>
				}
			</Grid>

		</Grid>
	)
}

const KVRenderNestedUser = ({ element, localstate, classes }) => {
	const user =
		getByPath(localstate?.itemdata, element.dbfield) ??
		localstate?.itemdata?.[element.dbfield];

	// FIX: Check the 'user' data object first, then fall back to the config element
    const placeholdervalue = user?.placeholdervalue || element.placeholdervalue;

	var displayName="";
	if (!placeholdervalue){
		const first = user?.firstname ?? user?.firstName ?? "";
		const last = user?.lastname ?? user?.lastName ?? "";
		displayName = [first, last].filter(Boolean).join(" ") || "—";
	} else {
		displayName = placeholdervalue;
	}
	

	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth ?? 170, flexShrink: 0, textAlign: "right" }}>
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>

			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
					{displayName}
				</div>
			</Grid>
		</Grid>
	);
};

const KVRenderUpdateUser = ({ element, localstate, classes, UpdateState, perms }) => {
	if (localstate.itemdata.updateuser) {
		return (
			<Grid container wrap="nowrap">
				<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
					{/* Label */}
					<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
						{element.label}
					</div>
				</Grid>
				<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
					{/* Value */}
					<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
						{localstate.itemdata.updateuser.firstname} {localstate.itemdata.updateuser.lastname}
					</div>
				</Grid>

			</Grid>
		)
	}
}

const KVRenderProductSelection = ({ configuration, element, localstate, classes, UpdateState, perms }) => {
	const onDBAutoCompleteChange = (newvalue, searchkey, itemindex) => {
		console.log(newvalue);
		//We can parse results by using keys - this makes the function reusable so we can insert many DBAutoComplete Components
		if (searchkey === "products") {
			//Check for update to inventory item system
			if (configuration.dbmodel === "flexitem") {
				localstate.itemdata.Mfg = newvalue.Mfg;
				localstate.itemdata.Model = newvalue.Name;
				localstate.itemdata.AssetType = newvalue.ProductType;
			}
			localstate.pendingupdate = true;
			localstate.itemdata.ProductID = newvalue.ProductID;
			UpdateState(localstate);
		}
	}

	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150, fontWeight: "300" }}>
				{/* Value */}
				<DBAutoComplete
					isnewstyle={true}
					keyedby="ID"
					searchtype="products"
					searchkey="Name"
					//itemindex={index}
					defaultsearchterm={(localstate.itemdata.product ? localstate.itemdata.product.Name : "")}
					limit="100"
					disabled={(perms.updatePerm ? false : true)}
					//errors={errors}
					allowadd={false}
					freeSolo={false}
					grayplaceholder="Add Product"
					onDBAutoCompleteChange={onDBAutoCompleteChange}
					endadornment={(localstate.itemdata.product ?
						<div style={{ textAlign: "right", display: "inline-block" }}>
							<Link
								to={{
									pathname: "/product/" + localstate.itemdata.product.ProductID,
								}}
							>
								<OpenInNewIcon className={classes.transparenticon} color="primary" fontSize="medium">
								</OpenInNewIcon>
							</Link>

							<a href={hostbase + "/inventorymanager?ProductID=" + encodeURIComponent(localstate.itemdata.product.ProductID) + "&ProductName=" + encodeURIComponent(localstate.itemdata.product.Name)} target="_blank">
								<ViewListIcon className={classes.transparenticon} color="primary" fontSize="medium">
								</ViewListIcon>
							</a>
						</div> : false)
					}
					endadornmentsize={"45px"}
				/>
			</Grid>

		</Grid>
	)
}


// add near your other helpers
const getByPath = (obj, path) => {
	if (!obj || !path) return undefined;
	return path
		.replace(/\[(\d+)\]/g, ".$1")
		.split(".")
		.reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
};


const KVRenderPartSelection = ({ element, localstate, classes, UpdateState, perms }) => {


	const onDBAutoCompleteChange = (newvalue, searchkey, itemindex) => {
		console.log(searchkey);
		console.log(newvalue);
		//We can parse results by using keys - this makes the function reusable so we can insert many DBAutoComplete Components
		if (searchkey === "parts") {
			//console.log("Set new value: "+newvalue.Vendor);
			//setDBAC(newvalue.Vendor);

			localstate.pendingupdate = true;
			localstate.itemdata.PartID = newvalue.PartID;
			//ToggleSaveBtnStatus(true);
			UpdateState(localstate);

		}
	}

	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				<DBAutoComplete
					keyedby="ID"
					searchtype="parts"
					searchkey="Name"
					//itemindex={index}
					defaultsearchterm={(localstate.itemdata.part ? localstate.itemdata.part.Name : "")}
					limit="100"
					disabled={(perms.updatePerm ? false : true)}
					//errors={errors}
					allowadd={false}
					freeSolo={false}
					//grayplaceholder="Add Product" 
					onDBAutoCompleteChange={onDBAutoCompleteChange}
					endadornment={(localstate.itemdata.part ?
						<div style={{ textAlign: "right", display: "inline-block" }}>
							<Link
								to={{
									pathname: "/part/" + localstate.itemdata.part.ID,
								}}
							>
								<OpenInNewIcon className={classes.transparenticon} color="primary" fontSize="medium">
								</OpenInNewIcon>
							</Link>
						</div> : false)
					}
					endadornmentsize={"45px"}
				/>
			</Grid>

		</Grid>
	)
}





const KVRenderInputTextArea = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				<TextareaAutosize
					disabled={perms.updatePerm ? false : true}
					style={{ minHeight: "50px", backgroundColor: element.backgroundColor }}
					className={classes.kvtextinput}
					value={localstate.itemdata[element.dbfield]}
					onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
				/>
			</Grid>

		</Grid>
	)
}

const KVRenderInputCheckbox = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150, textAlign: element.valuetextAlign }}>
				{/* Value */}
				<Checkbox
					sx={{ padding: "0px" }}
					checked={(localstate.itemdata[element.dbfield] === 1 ? true : false)}
					onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })} />
			</Grid>

		</Grid>
	)
}

const KVRenderAddTags = ({ element, localstate, classes, UpdateState, perms }) => {
	const onChangeTag = ({ event, localstate, UpdateState, element }) => {
		console.log(event.target.value);
		if (event.key === "Enter") {
			if (event.target.value.length < 1) {
				//errors.NewError({ errmsg: "Conditions must be 2 characters or more.", errshow: true, errtimeout: 5, errtype: "warning" })
			} else {
				console.log(event.target.value);

				//Construct new child record:
				const childrecord = {
					PendingItem: 1,
					[element.tagkey]: event.target.value.trim(),
				};

				(element.defaultmappings || []).forEach((m) => {
					if (m.from) childrecord[m.key] = localstate.itemdata?.[m.from] ?? null;
					else if ("value" in m) childrecord[m.key] = m.value;
				});
				localstate.itemdata[element.dbfield].push(childrecord);
				console.log(localstate.itemdata[element.dbfield]);
				event.target.value = ""; //I can't believe I've been using refs or values when this works.
				localstate.pendingupdate = 1;
				UpdateState(localstate);
			}
		}
	}

	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150, textAlign: element.valuetextAlign }}>
				{/* Value */}
				{(perms.updatePerm) &&
					<input className={classes.kvtextinput} style={{ textAlign: element.valuetextAlign }}
						maxLength="100" //Needs max length
						type="text"
						placeholder={element.placeholder}
						//value={localstate.itemdata[element.dbfield]}
						onKeyUp={(event) => onChangeTag({ event, localstate, UpdateState, element })}
					/>
				}
				{(!perms.updatePerm) &&
					<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
						{localstate.itemdata[element.dbfield]}
					</div>
				}
			</Grid>

		</Grid>
	)
}

// Build the style for one child record
const getTagStyle = (element, childrecord) => {
	// 1) Start with base/default style
	let style = { ...(element.defaultstyle || {}) };

	const rules = element.conditionalstyles || [];
	let matched = false;

	// 2) Apply matching conditional rules
	rules.forEach(({ key, value, ...cssprops }) => {
		// skip fallback rules in this pass
		if (key == null) return;

		if (childrecord[key] === value) {
			matched = true;
			style = { ...style, ...cssprops };
		}
	});

	// 3) If nothing matched, apply fallback rule(s)
	// Convention: fallback rule has { key: null } (or undefined)
	rules.forEach(({ key, ...cssprops }) => {
		if (!matched && key == null) {
			style = { ...style, ...cssprops };
		}
	});

	return style;
};




const KVRenderTags = ({ element, localstate, classes, UpdateState, perms }) => {
	const children = localstate.itemdata[element.dbfield] || [];

	const DeleteTag = (tagindex) => {
		localstate.itemdata[element.dbfield][tagindex].DeleteItem = 1;
		localstate.pendingupdate = 1;
		UpdateState({ ...localstate });
	};

	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0 }}>
				<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign, padding: "4px 0px 0px 5px" }}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150, textAlign: element.valuetextAlign, padding: "2px 0px 0px 5px" }}>
				{children.map((childrecord, childrecordindex) => {
					const isDeleted = childrecord.DeleteItem === 1;

					return (
						<div
							key={childrecord.ID ?? childrecordindex}
							style={{
								display: element.inline ? "inline-block" : "block",
								padding: "0px 0px 0px 7px",
								margin: "0 4px 4px 0",
								...getTagStyle(element, childrecord),
								...(isDeleted
									? {
										height: "26px",
										padding: "0px 3px 6px 6px",
										verticalAlign: "top",
										background: "#BBB",
										color: "#333",
										textDecoration: "line-through",
									}
									: {}),
							}}
						>
							{perms.updatePerm && !isDeleted && (
								<CloseIcon
									className={classes.conditiondeleteicon}
									style={{ backgroundColor: "hsla(0, 0%, 0%, 0.15)", height: "20px", width: "20px", borderRadius: "3px", margin: "2px", float: "right" }}
									onClick={() => DeleteTag(childrecordindex)}
								/>
							)}

							{childrecord[element.tagkey]}&nbsp;

						</div>
					);
				})}
			</Grid>
		</Grid>
	);
};


const MiniGrid = ({ element, localstate, classes, UpdateState, perms }) => {
	const records = localstate.itemdata[element.dbfield] || [];
	const columns = element.columns || [];
	const showActions = !!(element.allowdelete && perms.updatePerm);

	const setRows = (rows) => {
		const next = { ...localstate };
		next.itemdata = { ...next.itemdata, [element.dbfield]: rows };
		next.pendingupdate = 1;
		UpdateState(next);
	};

	const AddRow = () => {
		const row = { PendingItem: 1, SoftDelete: 0 };
		(element.defaultmappings || []).forEach((m) => {
			if (m.from) row[m.key] = localstate.itemdata?.[m.from] ?? null;
			else if ("value" in m) row[m.key] = m.value;
		});
		setRows([...(records || []), row]);
	};

	const DeleteRow = (idx) => {
		const rows = [...records];
		rows[idx] = { ...rows[idx], DeleteItem: 1 };
		setRows(rows);
	};

	const UpdateCell = (idx, field, value) => {
		const rows = [...records];
		rows[idx] = { ...rows[idx], [field]: value, PendingItem: rows[idx]?.PendingItem ?? 1 };
		setRows(rows);
	};

	const renderStaticText = (row, col) => {
        const value = row[col.dbfield];

        if (col.format === "userfull") {
            if (value && typeof value === "object") {
                const full = `${value.firstname ?? ""} ${value.lastname ?? ""}`.trim();
                return full || (col.fallback ?? "—");
            }
            return col.fallback ?? "—";
        }

        // Add Boolean Yes/No check
        if (col.renderyesnow || col.renderyesno) {
            // If the value is completely empty, default to "No" (or use fallback if provided)
            if (value === null || value === undefined || value === "") return col.fallback ?? "No";
            
            // Check common truthy DB values
            const isYes = value === true || value === 1 || value === "1" || String(value).toLowerCase() === "true";
            return isYes ? "Yes" : "No";
        }

        if (value === null || value === undefined || value === "") return col.fallback ?? "—";
        return String(value);
    };

	return (
		<div style={{ width: "100%", paddingBottom:"20px" }}>
			<div style={{ height: "30px", borderBottom: "2px solid #AAA", backgroundColor: "#DDD", textAlign: "left", padding: "5px 0px 1px 8px" }}>
				<span style={{ fontSize: "1.1em", fontWeight: "400" }}>
					{element.title}
				</span>
				{element.description ?
					<span style={{ fontSize: "0.8em" }}> - {element.description}</span> : ""
				}
			</div>
			<table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
				<thead>
					<tr>
						{columns.map((col) => (
							<th
								key={`hdr-${col.dbfield}`}
								style={{
									textAlign: col.labeltextAlign || "left",
									backgroundColor: "#EEE",
									borderBottom: "1px solid #CCC",
									padding: "2px 8px 0px 8px",
									fontSize: "0.9rem",
									fontWeight: 600,
									color: "#333",
									height: "25px",
									width: col.width || "auto"
								}}
							>
								{col.label || col.dbfield}
							</th>
						))}
						{showActions && (
							<th
								style={{
									width: "150px",
									textAlign: "center",
									backgroundColor: "#EEE",
									borderBottom: "1px solid #CCC",
									padding: "2px 8px 0px 8px",
									fontSize: "0.9rem",
									fontWeight: 600,
									color: "#333",
								}}
							>
								Actions
							</th>
						)}
					</tr>
				</thead>

				<tbody>
					{records.map((row, idx) => {
						if (Number(row.SoftDelete || 0) === 1) return null;
						const deleting = Number(row.DeleteItem || 0) === 1;

						return (
							<tr key={row.RepairID ?? row.ID ?? `row-${idx}`} style={{ opacity: deleting ? 0.6 : 1 }}>
								{columns.map((col) => (
									<td key={`${idx}-${col.dbfield}`} style={{ padding: "3px 0px", verticalAlign: "middle", width: col.width || "auto" }}>

										{col.rendertype === "minigridtextinput" && (
											<input
												className={classes.kvtextinput}
												style={{
													width: "100%",
													minHeight: "29px",
													boxSizing: "border-box",
													textAlign: col.valuetextAlign || "left",
													textDecoration: deleting ? "line-through" : "none",
													background: deleting ? "#EEE" : "#FFF",
												}}
												type="text"
												placeholder={col.placeholder}
												maxLength={Number(col.validation?.maxlength || 255)}
												value={row[col.dbfield] ?? ""}
												onChange={(e) => UpdateCell(idx, col.dbfield, e.target.value)}
												disabled={!perms.updatePerm || deleting}
											/>
										)}

										{col.rendertype === "minigridstatictext" && (
											<div
												className={classes.kvstaticinput}
												style={{
													minHeight: "29px",
													alignItems: "center",
													textAlign: col.valuetextAlign || "left",
													textDecoration: deleting ? "line-through" : "none",
													background: deleting ? "#EEE" : "transparent",
												}}
											>
												{renderStaticText(row, col)}
											</div>
										)}

										{col.rendertype === "minigriddatetime" && (() => {
											const raw = getByPath(row, col.dbfield);
											const d = raw ? dayjs(raw) : null;
											return (
												<div className={classes.kvstaticinput} style={{ textAlign: col.valuetextAlign || "left" }}>
													{d && d.isValid() ? d.format("MMMM D, YYYY [at] h:mma") : "—"}
												</div>
											);
										})()}


										{col.rendertype === "minigridselect" && (

											<FormControl variant="standard" className={classes.kvstaticselect} sx={{ m: 0, width: "100%", border: "0px" }}>
												<Select
													variant="standard"
													disableUnderline
													value={row[col.dbfield] ?? ""}
													onChange={(e) => UpdateCell(idx, col.dbfield, e.target.value === "" ? null : e.target.value)}
													disabled={!perms.updatePerm || deleting}
													displayEmpty
													renderValue={(selected) => {
														const opts = col.values || [];
														const match = opts.find((o) => o.value === selected);
														return match ? match.optionlabel : (selected ?? "—");
													}}
													sx={{
														width: "100%",
														minHeight: "29px",
														textAlign: col.valuetextAlign || "left",
														background: deleting ? "#EEE" : "#FFF",
														fontSize: "18px",
														fontWeight: 300,
														borderBottom: "1px solid #EEE",
														padding: "0px"
													}}
													label="this"
												>
													{(col.values || []).map((option, optionIndex) => (
														<MenuItem
															sx={{ padding: "6px", fontSize: "18px", fontWeight: 300 }}
															key={`${col.dbfield}-opt-${optionIndex}`}
															value={option.value ?? ""}
														>
															{option.optionlabel}
														</MenuItem>
													))}
												</Select>
											</FormControl>

										)}

										{col.rendertype === "minigridcheckbox" && (
											<div
												style={{
													minHeight: "29px",

													textAlign: col.valuetextAlign || "left",
													//   alignItems: "center",
													//   justifyContent: col.valuetextAlign === "right" ? "flex-end" : "flex-start",
													background: deleting ? "#EEE" : "transparent",
													paddingLeft: "6px",
													borderBottom: "1px solid #EEE",
												}}
											>
												<Checkbox
													sx={{ padding: "0px" }}
													checked={Number(getByPath(row, col.dbfield) ?? 0) === 1}
													onChange={(e) => UpdateCell(idx, col.dbfield, e.target.checked ? 1 : 0)}
													disabled={!perms.updatePerm || deleting}
												/>
											</div>
										)}

										{col.rendertype === "minigridsmartvalue" && (() => {
                                            let displayValue = "-";
                                            
                                            if (col.renderformats && Array.isArray(col.renderformats)) {
                                                for (const format of col.renderformats) {
                                                    const reqValue = getByPath(row, format.requires);
                                                    
                                                    // Check if the required field has a valid, non-empty value
                                                    if (reqValue !== null && reqValue !== undefined && String(reqValue).trim() !== "") {
                                                        
                                                        // Map the render items to their actual values
                                                        const parts = (format.renderitems || []).map(itemPath => {
                                                            const val = getByPath(row, itemPath);
                                                            return (val !== null && val !== undefined) ? String(val).trim() : "";
                                                        }).filter(Boolean); // Filter out empty strings
                                                        
                                                        if (parts.length > 0) {
                                                            displayValue = parts.join(" ");
                                                            break; // Stop at the first satisfied format
                                                        }
                                                    }
                                                }
                                            }

                                            return (
                                                <div
                                                    className={classes.kvstaticinput}
                                                    style={{
                                                        minHeight: "29px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        textAlign: col.valuetextAlign || "left",
                                                        textDecoration: deleting ? "line-through" : "none",
                                                        background: deleting ? "#EEE" : "transparent",
                                                    }}
                                                >
                                                    {displayValue}
                                                </div>
                                            );
                                        })()}



										{col.rendertype === "minigridcustomlink" && (() => {
                                            const textValue = getByPath(row, col.dbfield);
                                            const endValue = getByPath(row, col.linkend);
                                            
                                            const displayLabel = (textValue !== null && textValue !== undefined && String(textValue).trim() !== "") 
                                                ? String(textValue) 
                                                : "—";
                                                
                                            const hasValidLink = (endValue !== null && endValue !== undefined && String(endValue).trim() !== "");

                                            return (
                                                <div
                                                    className={classes.kvstaticinput}
                                                    style={{
                                                        minHeight: "29px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        textAlign: col.valuetextAlign || "left",
                                                        textDecoration: deleting ? "line-through" : "none",
                                                        background: deleting ? "#EEE" : "transparent",
                                                    }}
                                                >
                                                    {hasValidLink && !deleting && displayLabel !== "—" ? (
                                                        <a 
                                                            href={`${col.linkstart || ""}${encodeURIComponent(String(endValue))}`}
                                                            style={{ color: "#1976d2", textDecoration: "none" }}
                                                        >
                                                            {displayLabel}
                                                        </a>
                                                    ) : (
                                                        <span>{displayLabel}</span>
                                                    )}
                                                </div>
                                            );
                                        })()}














									</td>
								))}

								{showActions && (
									<td style={{ padding: "3px 0px", verticalAlign: "middle", textAlign: "center" }}>
										<div
											className={classes.kvstaticinput}
											style={{
												minHeight: "29px",
												minWidth: "150px",
												alignItems: "center",
												textAlign: "center",
												textDecoration: deleting ? "line-through" : "none",
												background: deleting ? "#EEE" : "transparent",
											}}
										>

											{!deleting ? (
												<a href="#" onClick={(e) => { e.preventDefault(); DeleteRow(idx); }} style={{ textDecoration: "none" }}>
													{element.deletebuttonlabel || "Delete"}
												</a>

												//   <Box className={classes.flexiitembtn}
												// 	  sx={{
												// 		  width: {
												// 			  xs: "100%",
												// 			  sm: "auto",
												// 		  },
												// 	  }}
												// 	  onClick={() => DeleteRow(idx)}
												//   >
												// 	  <Box className={classes.flexiitembtninner}>
												// 		  {element.deletebuttonlabel || "Delete"}
												// 	  </Box>
												//   </Box>
											) : (
												<span style={{ color: "#666" }}>Queued</span>
											)}
										</div>

									</td>
								)}
							</tr>
						);
					})}
				</tbody>
			</table>

			<div style={{ textAlign: "right", paddingRight:"20px" }}>
				{element.allowadd && perms.updatePerm && (
					<Box className={classes.flexiitembtn}
						sx={{
							width: {
								xs: "100%",
								sm: "auto",
							},
						}}
						onClick={AddRow}
					>
						<Box className={classes.flexiitembtninner}>
							{element.addbuttonlabel || "Add New"}
						</Box>
					</Box>
				)}
			</div>

		</div>
	);
};



// const KVAccordionObject = ({ element, localstate, classes }) => {
//   const getByPath = (obj, path) => {
//     if (!obj || !path) return undefined;
//     const keys = path.replace(/\[(\d+)\]/g, ".$1").split(".");
//     return keys.reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
//   };

//   const prettyLabel = (key) =>
//     String(key)
//       .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
//       .replace(/_/g, " ")
//       .replace(/\s+/g, " ")
//       .trim();

//   const raw = getByPath(localstate.itemdata, element.sourcepath);

// 	const formatDateLabel = (value) => { 
// 		if (!value) return "Unknown";
// 		const d = new Date(value);
// 		if (Number.isNaN(d.getTime())) return String(value);
// 		return d.toLocaleString(undefined, {
// 			year: "numeric",
// 			month: "short",
// 			day: "numeric",
// 			hour: "2-digit",
// 			minute: "2-digit",
// 		});
// 	};

// 	const customTitle =
//   element.titlebuilder
//     ? element.titlebuilder(specItem, specIndex)
//     : (element.title || `Spec ${specIndex + 1}`);

// const summaryTitle = typeof customTitle === "function"
//   ? customTitle(specItem, specIndex)
//   : customTitle;

//   const rows = Array.isArray(raw)
//     ? raw.filter(item => item && typeof item === "object")
//     : raw && typeof raw === "object"
//       ? [raw]
//       : [];

//   return (
//     <div style={{ border: "1px solid #DDD", borderRadius: 4, marginBottom: 10 }}>
//       {rows.length === 0 && (
//         <div style={{ padding: "10px" }} className={classes.kvstaticinput}>
//           —
//         </div>
//       )}

//       {rows.map((specItem, specIndex) => {
//         const entries = Object.entries(specItem || {});

//         const filtered = Array.isArray(element.fields) && element.fields.length > 0
//           ? entries.filter(([k]) => element.fields.includes(k))
//           : entries;

//         const visibleRows = Array.isArray(element.excludeFields) && element.excludeFields.length > 0
//           ? filtered.filter(([k]) => !element.excludeFields.includes(k))
//           : filtered;

//         return (
//           <details key={`spec-${specIndex}`} open={specIndex === 0 ? (element.defaultopen ?? true) : false}>
//             <summary
//               style={{
//                 cursor: "pointer",
//                 listStyle: "none",
//                 padding: "8px 10px",
//                 background: "#F5F5F5",
//                 borderBottom: "1px solid #E3E3E3",
//                 fontWeight: 500,
//               }}
//             >
//               {element.title || `Spec ${specIndex + 1}`}
//             </summary>

//             <div style={{ padding: "10px" }}>
//               <Grid container spacing={1.5}>
//                 {visibleRows.map(([key, value], idx) => {
//                   const label = (element.labels && element.labels[key]) || prettyLabel(key);

//                   return (
//                     <Grid item xs={12} md={6} key={`${key}-${idx}`}>
//                       <Grid container wrap="nowrap">
//                         <Grid sx={{ width: element.labelwidth || 180, flexShrink: 0, textAlign: "right" }}>
//                           <div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign || "right" }}>
//                             {label}:
//                           </div>
//                         </Grid>
//                         <Grid sx={{ flexGrow: 1, minWidth: 80 }}>
//                           <div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign || "left" }}>
//                             {value === null || value === undefined || value === "" ? "—" : String(value)}
//                           </div>
//                         </Grid>
//                       </Grid>
//                     </Grid>
//                   );
//                 })}
//               </Grid>
//             </div>
//           </details>
//         );
//       })}
//     </div>
//   );
// };


const KVAccordionSplit = ({ element, localstate, classes }) => {
	const hasValue = (v) => !(v === null || v === undefined || v === "");

	const shouldRenderField = (rec, field) => {
		if (!field?.renderdependency) return true;

		// string dependency: "HDD1Size"
		if (typeof field.renderdependency === "string") {
			return hasValue(rec?.[field.renderdependency]);
		}

		// array dependency: ["HDD1Size","HDD1Model"] => all must exist
		if (Array.isArray(field.renderdependency)) {
			return field.renderdependency.every((k) => hasValue(rec?.[k]));
		}

		return true;
	};

	const getByPath = (obj, path) => {
		if (!obj || !path) return undefined;
		const keys = path.replace(/\[(\d+)\]/g, ".$1").split(".");
		return keys.reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
	};

	const formatDateLabel = (value) => {
		if (!value) return "Unknown";
		const d = new Date(value);
		if (Number.isNaN(d.getTime())) return String(value);
		return d.toLocaleString(undefined, {
			year: "numeric",
			month: "short",
			day: "numeric",
			hour: "2-digit",
			minute: "2-digit"
		});
	};

	const readValue = (rec, field) => {
		const val = rec?.[field.key];

		if (field.format === "boolicon") {
			if (Number(val) === 1) {
				return <CheckIcon sx={{ color: "#2E7D32", verticalAlign: "middle" }} fontSize="small" />;
			}
			if (Number(val) === 0) {
				return <ErrorIcon sx={{ color: "#C62828", verticalAlign: "middle" }} fontSize="small" />;
			}
			return "—";
		}

		if (val === null || val === undefined || val === "") return "—";
		return String(val);
	};

	const renderRow = (rec, field, idx) => {
		const visible = shouldRenderField(rec, field);

		if (!visible) return null;

		return (
			<React.Fragment key={`${field.key}-${idx}`}>
				{field.header && (
					<div
						style={{
							width: "100%",
							fontWeight: 600,
							fontSize: "0.8rem",
							color: "#444",
							margin: "10px 0 4px 0",
							paddingTop: "12px",
							borderBottom: "1px solid #E0E0E0",
							letterSpacing: "0.02em",
						}}
					>
						{field.header}
					</div>
				)}

				<div
					style={{
						display: "flex",
						alignItems: "center",
						width: "100%",
						minWidth: 0,
						marginBottom: "6px",
					}}
				>
					<div
						style={{
							width: element.labelwidth || 170,
							flexShrink: 0,
							textAlign: element.labeltextAlign || "right",
							paddingRight: 8,
						}}
					>
						<span className={classes.kvlabel}>
							{field.label || field.key}
						</span>
					</div>

					<div
						style={{
							flex: 1,
							minWidth: 0,
							width: "100%",
							textAlign: element.valuetextAlign || "left",
						}}
					>
						<div className={classes.kvstaticinput} style={{ 
							width: "100%",
							overflow: "hidden",
							textOverflow: "ellipsis",
							whiteSpace: "wrap",
							}}>
							{readValue(rec, field)}
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	};

	const raw = getByPath(localstate.itemdata, element.sourcepath);
	const records = Array.isArray(raw)
		? raw.filter(item => item && typeof item === "object")
		: raw && typeof raw === "object"
			? [raw]
			: [];

	return (
		<>
			<div style={{ height: "30px", borderBottom: "2px solid #AAA", backgroundColor: "#DDD", textAlign: "left", padding: "5px 0px 1px 8px" }}>
				<span style={{ fontSize: "1.1em", fontWeight: "400" }}>
					{element.title}
				</span>
				{element.description ?
					<span style={{ fontSize: "0.8em" }}> - {element.description}</span> : ""
				}
			</div>
			<div style={{ border: "0px solid #DDD", borderRadius: 0, marginBottom: 10 }}>
				{records.length === 0 && (
					<div style={{ padding: "10px" }} className={classes.kvstaticinput}>—</div>
				)}

				{records.map((rec, idx) => {
					const title =
						typeof element.titlebuilder === "function"
							? element.titlebuilder(rec, idx, formatDateLabel)
							: (element.title || `Spec ${idx + 1}`);

					return (
						<details key={`split-spec-${idx}`} open={idx === 0 ? (element.defaultopen ?? true) : false} className={classes.detailsRoot}>
							<summary
								style={{
									cursor: "pointer",
									listStyle: "none",
									padding: "8px 10px",
									background: "#F5F5F5",
									borderBottom: "1px solid #E3E3E3",
									fontWeight: 500,
									textAlign:"left"
								}}
							>
								<span className={`caretIcon ${classes.caret}`}><ChevronRightIcon /></span>&nbsp;{title}
							</summary>

							<div style={{ padding: "10px" }} className={classes.detailsBody}>
								<Grid container spacing={4}>
									<Grid item xs={12} md={6} sx={{ minWidth: 0, maxWidth:"50%" }}>
										{(element.leftside || [])
											.filter((field) => shouldRenderField(rec, field))
											.map((field, fieldIdx) => renderRow(rec, field, fieldIdx))}
									</Grid>

									<Grid item xs={12} md={6} sx={{ minWidth: 0, maxWidth:"50%" }}>
										{(element.rightside || [])
											.filter((field) => shouldRenderField(rec, field))
											.map((field, fieldIdx) => renderRow(rec, field, fieldIdx))}
									</Grid>
								</Grid>
							</div>
						</details>
					);
				})}
			</div>
		</>
		
	);
};
const KVRenderEndButtons = ({ element, localstate, classes, UpdateState, perms }) => {

    //Give context so we can use userName
    const appContext = useContext(AppContext);
    const { userName } = appContext;

    // State for the More Options dropdown menu
    const [anchorEl, setAnchorEl] = useState(null);
    const menuOpen = Boolean(anchorEl);

    // Check if the item is already deleted or queued for deletion
    const isDeleted = Number(localstate.itemdata?.SoftDelete || 0) === 1 || Number(localstate.itemdata?.DeleteItem || 0) === 1;
    
    // Check if configuration enables the delete button under moreoptionsitems and user has permissions
    const showDeleteButton = element.moreoptionsitems?.deletebutton && !isDeleted && perms.deletePerm;
    
    // Determine if we even need to render the "More Options" button
    const hasMoreOptions = showDeleteButton; 

    return (
        <Grid container wrap="nowrap">
            <Grid sx={{ width: element.labelwidth || 150, flexShrink: 0, textAlign: "right" }}>
                {/* No Label */}
                <div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign || "left" }}>
                </div>
            </Grid>
            
            <Grid container sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150, alignItems: "center", justifyContent:"flex-end", marginTop:"40px", gap: "10px" }}>
                {/* Buttons Area */}
                
                {/* 1. MORE OPTIONS BUTTON & MENU */}
                {hasMoreOptions && (
                    <Grid sx={{ textAlign: "right" }}>
                        <Box 
                            className={classes.flexiitembtn}
                            sx={{
                                padding: "0px",
                                width: { xs: "100%", sm: "auto" },
                            }}
                            onClick={(e) => setAnchorEl(e.currentTarget)}
                        >
                            <Box className={classes.flexiitembtninner}>
                                More Options
                            </Box>
                        </Box>

                        <Menu
                            anchorEl={anchorEl}
                            open={menuOpen}
                            onClose={() => setAnchorEl(null)}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        >
                            {/* Delete Menu Item */}
                            {showDeleteButton && (
                                <MenuItem 
                                    onClick={() => {
                                        setAnchorEl(null); // Close menu first
                                        localstate.itemdata.DeleteItem = 1;
                                        localstate.pendingupdate = true;
                                        UpdateState({ ...localstate });
                                    }}
                                    sx={{ color: '#d32f2f' }} 
                                >
                                    <DeleteForeverIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                                    {element.moreoptionsitems.deletebuttonlabel || "Delete Item"}
                                </MenuItem>
                            )}
                        </Menu>
                    </Grid>
                )}
                
                {/* 2. CUSTOM BUTTONS */}
                {(element.custombuttons || []).map((btnConfig, index) => {
                    // Check render dependencies
                    if (Array.isArray(btnConfig.renderdependencies)) {
                        const passesDependencies = btnConfig.renderdependencies.every(dep => {
                            // Grab the value from state (fallback to 0/empty for uninitialized fields)
                            let val = localstate.itemdata?.[dep.key];
                            if (val === null || val === undefined) val = "0"; 
                            
                            // Loose equality handles DB ints (0) matching Config strings ("0")
                            return val == dep.value; 
                        });
                        
                        // Skip rendering this button if dependencies aren't met
                        if (!passesDependencies) return null;
                    }

                    const IconComponent = btnConfig.optionicon;
                    return (
                        <Grid key={`custom-btn-${index}`} sx={{ textAlign: "right" }}>
                            <Box 
                                className={classes.flexiitembtn}
                                sx={{
                                    padding: "0px",
                                    width: { xs: "100%", sm: "auto" },
                                }}
                                onClick={() => {
                                    if (typeof btnConfig.buttonFn === 'function') {
                                        btnConfig.buttonFn({ localstate, UpdateState, element, perms, userName });
                                    }
                                }}
                            >
                                <Box className={classes.flexiitembtninner}>
                                    {IconComponent && <IconComponent sx={{ mr: 1, verticalAlign: "middle" }} />}
                                    {btnConfig.buttonlabel}
                                </Box>
                            </Box>
                        </Grid>
                    );
                })}
                
            </Grid>
        </Grid>
    );
};





function FlexiItemContent({ configuration, localstate, UpdateState, classes, perms, dispatch }) {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			{configuration.contentelements.map((element, elementindex) => {
				return (
					<RenderElement
						key={element.dbfield + "toplevel" + elementindex}
						configuration={configuration}
						element={element}
						localstate={localstate}
						UpdateState={UpdateState}
						perms={perms}
						classes={classes} />
				)
			})}
		</LocalizationProvider>
	)
}

export default FlexiItemContent;